import { useQuery } from '@tanstack/react-query'
import { getMultiCartComments } from 'api/cart/getMultiCartComments'
import { COMMENT_QUERY_KEY, COMMENT_POLLING_INTERVAL } from 'constants/comments'

interface UseMultiCartCommentsParams {
  multiCartId: string
  itemIds?: Array<string>
  enabled?: boolean
  polling?: boolean
}

export function useMultiCartComments({
  multiCartId,
  itemIds,
  enabled = true,
  polling = false
}: UseMultiCartCommentsParams) {
  const sortedItemIds = itemIds?.slice().sort()

  return useQuery(
    [COMMENT_QUERY_KEY, multiCartId, sortedItemIds],
    ({ signal }) => getMultiCartComments(multiCartId, itemIds, { signal }),
    {
      enabled: enabled && !!multiCartId,
      staleTime: 0,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchInterval: polling ? COMMENT_POLLING_INTERVAL : false,
      refetchIntervalInBackground: false
    }
  )
}
